import React, { useState, useEffect, useRef, useCallback } from 'react'; // <<< Důležité: Přidán useCallback
import { 
    getFirestore, 
    doc, 
    setDoc, 
    getDoc, 
    collection, 
    query, 
    onSnapshot, 
    addDoc,
    deleteDoc, 
    getDocs, 
    where, 
    orderBy, // <<< Důležité: Přidán orderBy
    updateDoc // <<< Důležité: Přidán updateDoc
} from 'firebase/firestore'; 

// Import the purchases data
const purchasesData = require('../purchases.json'); 

// Update the MyScripts component to fetch from the correct database location
const MyScripts = ({ user, db, userDiscordData, setModalMessage, setCurrentPage, setActivityLog, onShowClaimModal, onShowUpdatesModal }) => {
    const [scripts, setScripts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [claimingRoles, setClaimingRoles] = useState({}); // Track which roles are being claimed

    // Debug log to check userDiscordData prop (can be removed in production)
    console.log('MyScripts - userDiscordData:', userDiscordData);

    // Fetch scripts from the user's my-scripts subcollection
    useEffect(() => {
        // Defensive: Check for valid user and db
        if (!user || !db) {
            console.warn("MyScripts: user or db not available, skipping script fetch");
            setIsLoading(false);
            return;
        }

        // Defensive: Check db is a Firestore instance (has .app and .type === 'firestore')
        if (typeof db !== 'object' || !db.app || db.type !== 'firestore') {
            console.error("MyScripts: db is not a valid Firestore instance");
            setModalMessage('Database connection error. Please try again later.');
            setIsLoading(false);
            return;
        }

        try {
            const userScriptsRef = collection(db, `users/${user.uid}/my-scripts`);
            
            const unsubscribe = onSnapshot(userScriptsRef, 
                (snapshot) => {
                    const scriptsData = [];
                    snapshot.forEach((doc) => {
                        scriptsData.push({ id: doc.id, ...doc.data() });
                    });
                    setScripts(scriptsData);
                    setIsLoading(false);
                },
                (error) => {
                    console.error("Error fetching scripts:", error);
                    setModalMessage('Failed to fetch scripts. Please try again later.');
                    setIsLoading(false);
                }
            );

            return () => unsubscribe();
        } catch (error) {
            console.error("MyScripts setup error:", error);
            setModalMessage('Failed to initialize scripts. Please refresh and try again.');
            setIsLoading(false);
        }
    }, [user, db, setModalMessage]);

    // Helper function to convert script name to script ID
    const getScriptIdFromName = (scriptName) => {
        // Remove prefixes like [ESX/QB/QBX], [ESX], etc. and extract the actual script name
        const cleanedName = scriptName.replace(/^\[.*?\]\s*/, '').toLowerCase().replace(/\s+/g, '-');
        return cleanedName;
    };

const handleClaimRole = async (scriptId, scriptName) => {
    if (!userDiscordData || !userDiscordData.id) {
        setModalMessage('❌ Please connect your Discord account first to claim roles.');
        return;
    }

    setModalMessage('🔄 Claiming Discord role...');
    
    try {
        // Connect to your VPS bot API
        const response = await fetch('http://185.91.116.105:3004/api/discord/assign-role', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                    discordId: userDiscordData.id,
                    scriptId: getScriptIdFromName(scriptName),
                    scriptName: scriptName
            }),
        });

        const data = await response.json();

        if (data.success) {
            setModalMessage(`🎉 ${data.message}`);
        } else {
            setModalMessage(`❌ Failed to claim role: ${data.error}`);
        }
    } catch (error) {
        console.error('Error claiming Discord role:', error);
        setModalMessage('❌ Failed to connect to Discord bot. Please try again later.');
    }
};

    if (isLoading) {
        return (
            <div className="glass-card p-8 rounded-2xl flex-grow min-h-[600px] flex items-center justify-center animate-fadeIn">
                <div className="text-center">
                    <div className="relative mb-6">
                        <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500/20 border-t-blue-500 mx-auto animate-glow"></div>
                        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500/20 to-purple-500/20 animate-pulse"></div>
                    </div>
                    <div className="space-y-2">
                        <p className="text-xl font-semibold gradient-text animate-slideInLeft">Loading Your Scripts</p>
                        <p className="text-gray-400 animate-fadeIn" style={{ animationDelay: '0.3s' }}>Fetching your collection...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="glass-card p-8 rounded-2xl flex-grow min-h-[600px] animate-fadeIn">
            {/* Header with Claim Script button */}
            <div className="flex items-center justify-between mb-8 animate-slideInLeft">
                <div className="relative">
                    <div className="absolute -inset-1 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl blur-xl animate-pulse"></div>
                    <div className="relative">
                        <h3 className="text-4xl font-bold gradient-text mb-3 animate-slideInLeft">My Scripts</h3>
                        <div className="flex items-center space-x-4">
                            <div className="flex items-center space-x-2 text-gray-400 animate-fadeIn" style={{ animationDelay: '0.2s' }}>
                                <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                                <span className="text-sm font-medium">
                                    {scripts.length > 0 ? `${scripts.length} active script${scripts.length > 1 ? 's' : ''}` : 'Ready to claim scripts'}
                                </span>
                            </div>
                            <div className="flex items-center space-x-2 text-gray-500 text-xs animate-fadeIn" style={{ animationDelay: '0.3s' }}>
                                <i className="fas fa-cube"></i>
                                <span>Personal Collection</span>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    onClick={() => onShowClaimModal()}
                    className="group relative overflow-hidden bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white font-bold py-4 px-8 rounded-xl transition-all duration-500 shadow-lg hover:shadow-2xl hover:shadow-blue-500/30 hover:-translate-y-2 hover:scale-105 animate-bounceIn"
                    style={{ animationDelay: '0.4s' }}
                >
                    {/* Shimmer overlay */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 animate-shimmer"></div>
                    
                    {/* Background pulse */}
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-400/20 to-purple-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-heartbeat"></div>
                    
                    <div className="relative flex items-center space-x-3">
                        <div className="w-6 h-6 rounded-lg bg-white/10 flex items-center justify-center group-hover:rotate-180 transition-transform duration-500">
                            <i className="fas fa-download text-sm"></i>
                        </div>
                        <span className="font-semibold">Claim Script</span>
                        <div className="w-2 h-2 rounded-full bg-white/60 opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300"></div>
                    </div>
                    
                    {/* Glow effect */}
                    <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl opacity-0 group-hover:opacity-20 blur-xl transition-all duration-500"></div>
                </button>
            </div>
            
            {scripts.length === 0 ? (
                <div className="flex flex-col items-center justify-center flex-grow text-center py-20 animate-fadeIn">
                    <div className="relative mb-8">
                        {/* Animated background rings */}
                        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500/10 to-purple-500/10 animate-ping" style={{ animationDuration: '3s' }}></div>
                        <div className="absolute inset-4 rounded-full bg-gradient-to-r from-blue-500/5 to-purple-500/5 animate-ping" style={{ animationDuration: '2s', animationDelay: '0.5s' }}></div>
                        
                        {/* Main icon */}
                        <div className="relative w-32 h-32 mx-auto rounded-3xl bg-gradient-to-br from-blue-600/20 to-purple-600/20 flex items-center justify-center animate-float">
                            <i className="fas fa-code text-6xl text-blue-400 animate-pulse"></i>
                        </div>
                        
                        {/* Floating particles */}
                        <div className="absolute top-4 left-4 w-2 h-2 rounded-full bg-blue-400/60 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                        <div className="absolute top-8 right-6 w-1.5 h-1.5 rounded-full bg-purple-400/60 animate-bounce" style={{ animationDelay: '0.8s' }}></div>
                        <div className="absolute bottom-6 left-8 w-1 h-1 rounded-full bg-green-300/60 animate-bounce" style={{ animationDelay: '1.2s' }}></div>
                    </div>
                    
                    <div className="space-y-4 max-w-md">
                        <h3 className="text-3xl font-bold gradient-text animate-slideInLeft" style={{ animationDelay: '0.3s' }}>
                            No Scripts Yet
                        </h3>
                        <p className="text-gray-300 text-lg leading-relaxed animate-slideInLeft" style={{ animationDelay: '0.5s' }}>
                            Ready to claim your first script?
                        </p>
                        <p className="text-gray-400 text-sm leading-relaxed animate-slideInLeft" style={{ animationDelay: '0.7s' }}>
                            Click "Claim Script" above to add purchased scripts to your collection and unlock exclusive Discord roles.
                        </p>
                        
                        {/* Feature highlights */}
                        <div className="grid grid-cols-2 gap-4 mt-8 animate-slideInLeft" style={{ animationDelay: '0.9s' }}>
                            <div className="bg-white/5 rounded-xl p-4 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1">
                                <i className="fab fa-discord text-blue-400 text-xl mb-2"></i>
                                <p className="text-xs text-gray-300 font-medium">Discord Roles</p>
                            </div>
                            <div className="bg-white/5 rounded-xl p-4 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1">
                                <i className="fas fa-sync-alt text-purple-400 text-xl mb-2"></i>
                                <p className="text-xs text-gray-300 font-medium">Auto Updates</p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {scripts.map((script, index) => (
                        <div 
                            key={script.id} 
                            className="group relative overflow-hidden rounded-2xl glass-card border border-white/10 hover:border-blue-400/50 transition-all duration-700 hover:-translate-y-3 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/25 animate-fadeIn hover-lift"
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            {/* Shimmer overlay */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                            
                            {/* Gradient background overlay on hover */}
                            <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 via-purple-600/5 to-cyan-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            
                            {/* Animated border glow */}
                            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-400/20 via-transparent to-purple-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm"></div>
                            
                            <div className="relative h-full flex flex-col">
                                {/* Enhanced Script Preview/Header Image */}
                                <div className="relative mb-6">
                                    <div className="aspect-video bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 relative overflow-hidden rounded-t-2xl group-hover:bg-gradient-to-br group-hover:from-gray-700 group-hover:via-gray-600 group-hover:to-gray-700 transition-all duration-500">
                                        {/* Preview Content with enhanced styling */}
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <div className="text-center transform group-hover:scale-110 transition-transform duration-500">
                                                <div className="relative w-20 h-20 mx-auto mb-4">
                                                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 animate-pulse opacity-80 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-400 to-purple-500 animate-ping opacity-20" style={{ animationDuration: '2s' }}></div>
                                                    <div className="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
                                                        <i className="fas fa-cube text-white text-2xl group-hover:rotate-12 transition-transform duration-300"></i>
                                                    </div>
                                                </div>
                                                <p className="text-gray-400 text-sm font-medium group-hover:text-gray-300 transition-colors duration-300">Script Preview</p>
                                            </div>
                                        </div>
                                        
                                        {/* Enhanced gradient overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent group-hover:from-black/40 transition-all duration-500"></div>
                                        
                                        {/* Enhanced status indicator */}
                                        <div className="absolute top-4 left-4">
                                            <div className="flex items-center space-x-2 bg-black/60 backdrop-blur-sm rounded-full px-4 py-2 group-hover:bg-black/40 transition-all duration-300">
                                                <div className="relative">
                                                    <span className="inline-block w-3 h-3 bg-green-400 rounded-full animate-pulse"></span>
                                                    <span className="absolute inset-0 w-3 h-3 bg-green-400 rounded-full animate-ping opacity-50"></span>
                                                </div>
                                                <span className="text-sm text-green-400 font-bold">Active</span>
                                            </div>
                                        </div>
                                        
                                        {/* Enhanced price badge */}
                                        {(script.originalPrice !== undefined && script.originalPrice !== null) && (
                                            <div className="absolute top-4 right-4">
                                                <div className="relative group/price">
                                                    <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg group-hover:shadow-xl group-hover:shadow-blue-500/25 transition-all duration-300">
                                                        {script.originalPrice === 0 || script.originalPrice === "0" || script.originalPrice === "0.00" 
                                                            ? "Free" 
                                                            : `${script.originalPrice} ${script.currency}`}
                                                    </div>
                                                    <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full opacity-0 group-hover/price:opacity-30 blur transition-all duration-300"></div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="px-6 pb-6 flex flex-col flex-grow">
                                    {/* Script Icon and basic info with enhanced styling */}
                                    <div className="flex items-start justify-between mb-6">
                                        <div className="flex items-center space-x-3">
                                            <div className="relative">
                                                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 border border-blue-500/30 flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                                                    <i className="fas fa-code text-blue-400 text-lg"></i>
                                                </div>
                                                <div className="absolute -inset-1 bg-gradient-to-br from-blue-500/20 to-purple-600/20 rounded-xl opacity-0 group-hover:opacity-50 blur transition-all duration-300"></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Enhanced Script Title */}
                                    <div className="mb-6">
                                        <h4 className="text-xl font-bold text-white mb-3 leading-tight line-clamp-2 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-blue-400 group-hover:to-purple-400 group-hover:bg-clip-text transition-all duration-500">
                                            {script.name}
                                        </h4>
                                        <div className="h-1 w-0 bg-gradient-to-r from-blue-400 to-purple-400 group-hover:w-full transition-all duration-500 rounded-full"></div>
                                    </div>

                                    {/* Enhanced Script details */}
                                    <div className="space-y-4 mb-8 flex-grow">
                                        {script.claimedAt && (
                                            <div className="flex items-center space-x-4 p-3 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-xl border border-blue-500/20 group-hover:border-blue-400/50 transition-all duration-300">
                                                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                                    <i className="fas fa-calendar text-blue-400 animate-pulse"></i>
                                                </div>
                                                <div className="flex-grow">
                                                    <p className="text-blue-400 font-bold text-sm uppercase tracking-wide">Claimed Date</p>
                                                    <p className="text-gray-300 font-semibold">{new Date(script.claimedAt).toLocaleDateString()}</p>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {script.packageId && (
                                            <div className="flex items-center space-x-4 p-3 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-xl border border-purple-500/20 group-hover:border-purple-400/50 transition-all duration-300">
                                                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                                    <i className="fas fa-tag text-purple-400 animate-pulse"></i>
                                                </div>
                                                <div className="flex-grow">
                                                    <p className="text-purple-400 font-bold text-sm uppercase tracking-wide">Package ID</p>
                                                    <p className="text-gray-300 font-mono text-sm truncate">{script.packageId}</p>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {script.purchaseId && (
                                            <div className="flex items-center space-x-4 p-3 bg-gradient-to-r from-orange-500/10 to-yellow-500/10 rounded-xl border border-orange-500/20 group-hover:border-orange-400/50 transition-all duration-300">
                                                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-orange-500/20 to-yellow-500/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                                    <i className="fas fa-receipt text-orange-400 animate-pulse"></i>
                                                </div>
                                                <div className="flex-grow">
                                                    <p className="text-orange-400 font-bold text-sm uppercase tracking-wide">Purchase ID</p>
                                                    <p className="text-gray-300 font-mono text-sm truncate">{script.purchaseId}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Enhanced Action buttons */}
                                    <div className="space-y-4">
                                        {/* Updates Button with enhanced styling */}
                                        <button
                                            onClick={() => {
                                                onShowUpdatesModal(script);
                                            }}
                                            className="w-full group/btn relative overflow-hidden bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white font-bold py-4 px-6 rounded-xl transition-all duration-500 shadow-lg hover:shadow-2xl hover:shadow-green-500/30 hover:-translate-y-1 hover:scale-105"
                                            title="View Updates"
                                        >
                                            <div className="absolute inset-0 bg-gradient-to-r from-green-400/20 to-emerald-400/20 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>
                                            <div className="relative flex items-center justify-center space-x-2">
                                                <i className="fas fa-sync-alt text-lg group-hover/btn:rotate-180 transition-transform duration-500"></i>
                                                <span>View Updates</span>
                                                <div className="w-2 h-2 rounded-full bg-white/60 opacity-0 group-hover/btn:opacity-100 animate-pulse transition-opacity duration-300"></div>
                                            </div>
                                            <div className="absolute -inset-1 bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl opacity-0 group-hover/btn:opacity-20 blur-xl transition-all duration-500"></div>
                                        </button>
                                        
                                        {/* Enhanced Discord Role Button */}
                                        <button
                                            onClick={() => handleClaimRole(script.id || script.packageId, script.name)}
                                            disabled={!userDiscordData || claimingRoles[script.id || script.packageId]}
                                            className={`w-full group/btn relative overflow-hidden font-bold py-4 px-6 rounded-xl transition-all duration-500 shadow-lg hover:shadow-2xl hover:-translate-y-1 hover:scale-105 ${
                                                !userDiscordData 
                                                    ? 'bg-gradient-to-r from-gray-600 to-gray-700 text-gray-400 cursor-not-allowed' 
                                                    : claimingRoles[script.id || script.packageId]
                                                        ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white cursor-wait'
                                                        : 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white hover:shadow-purple-500/30'
                                            }`}
                                            title={
                                                !userDiscordData 
                                                    ? 'Connect Discord account to claim roles' 
                                                    : 'Claim Discord role for this script'
                                            }
                                        >
                                            {!claimingRoles[script.id || script.packageId] && (
                                                <div className="absolute inset-0 bg-gradient-to-r from-purple-400/20 to-pink-400/20 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>
                                            )}
                                            
                                            <div className="relative flex items-center justify-center space-x-2">
                                                {claimingRoles[script.id || script.packageId] ? (
                                                    <>
                                                        <div className="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
                                                        <span>Claiming Role...</span>
                                                    </>
                                                ) : !userDiscordData ? (
                                                    <>
                                                        <i className="fab fa-discord text-lg"></i>
                                                        <span>Connect Discord</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fab fa-discord text-lg group-hover/btn:scale-110 transition-transform duration-300"></i>
                                                        <span>Claim Role</span>
                                                        <div className="w-2 h-2 rounded-full bg-white/60 opacity-0 group-hover/btn:opacity-100 animate-pulse transition-opacity duration-300"></div>
                                                    </>
                                                )}
                                            </div>
                                            
                                            {!claimingRoles[script.id || script.packageId] && userDiscordData && (
                                                <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl opacity-0 group-hover/btn:opacity-20 blur-xl transition-all duration-500"></div>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            
            {/* Enhanced Discord connection prompt */}
            {!userDiscordData && (
                <div className="mt-8 relative overflow-hidden rounded-2xl glass-card border border-yellow-500/30 p-8 animate-fadeIn">
                    {/* Enhanced background overlay with animation */}
                    <div className="absolute inset-0 bg-gradient-to-br from-yellow-600/10 via-orange-600/5 to-yellow-600/10 animate-pulse"></div>
                    
                    {/* Shimmer effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-400/5 to-transparent -translate-x-full animate-shimmer"></div>
                    
                    <div className="relative flex items-center space-x-6">
                        <div className="flex-shrink-0">
                            <div className="relative">
                                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-yellow-500 to-orange-500 flex items-center justify-center shadow-lg hover:shadow-2xl hover:shadow-yellow-500/25 transition-all duration-300 hover:scale-110 hover:rotate-6">
                                    <i className="fab fa-discord text-white text-3xl"></i>
                                </div>
                                
                                {/* Animated ring */}
                                <div className="absolute -inset-2 rounded-2xl bg-gradient-to-br from-yellow-500/20 to-orange-500/20 animate-ping opacity-75"></div>
                            </div>
                        </div>
                        
                        <div className="flex-grow">
                            <h4 className="text-2xl font-bold gradient-text mb-3 animate-slideInLeft">
                                Connect Discord for Role Access
                            </h4>
                            <p className="text-gray-300 text-base mb-6 leading-relaxed animate-slideInLeft" style={{ animationDelay: '0.2s' }}>
                                Connect your Discord account to claim exclusive roles for your purchased scripts and get access to support channels.
                            </p>
                            
                            {/* Feature list */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 animate-slideInLeft" style={{ animationDelay: '0.4s' }}>
                                <div className="flex items-center space-x-3 p-3 bg-white/5 rounded-xl hover:bg-white/10 transition-all duration-300">
                                    <i className="fas fa-crown text-yellow-400"></i>
                                    <span className="text-sm text-gray-300 font-medium">Exclusive Roles</span>
                                </div>
                                <div className="flex items-center space-x-3 p-3 bg-white/5 rounded-xl hover:bg-white/10 transition-all duration-300">
                                    <i className="fas fa-comments text-blue-400"></i>
                                    <span className="text-sm text-gray-300 font-medium">Support Access</span>
                                </div>
                                <div className="flex items-center space-x-3 p-3 bg-white/5 rounded-xl hover:bg-white/10 transition-all duration-300">
                                    <i className="fas fa-bell text-green-400"></i>
                                    <span className="text-sm text-gray-300 font-medium">Update Notifications</span>
                                </div>
                                <div className="flex items-center space-x-3 p-3 bg-white/5 rounded-xl hover:bg-white/10 transition-all duration-300">
                                    <i className="fas fa-users text-purple-400"></i>
                                    <span className="text-sm text-gray-300 font-medium">Community Access</span>
                                </div>
                            </div>
                            
                            <button
                                onClick={() => setCurrentPage('settings')}
                                className="group relative overflow-hidden bg-gradient-to-r from-yellow-600 to-orange-600 hover:from-yellow-500 hover:to-orange-500 text-white font-bold py-4 px-8 rounded-xl transition-all duration-500 shadow-lg hover:shadow-2xl hover:shadow-yellow-500/30 hover:-translate-y-1 hover:scale-105 animate-bounceIn"
                                style={{ animationDelay: '0.6s' }}
                            >
                                {/* Shimmer overlay */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                
                                <div className="relative flex items-center space-x-3">
                                    <i className="fab fa-discord text-xl group-hover:scale-110 transition-transform duration-300"></i>
                                    <span className="font-semibold">Connect Discord Account</span>
                                    <div className="w-2 h-2 rounded-full bg-white/60 opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300"></div>
                                </div>
                                
                                {/* Glow effect */}
                                <div className="absolute -inset-1 bg-gradient-to-r from-yellow-600 to-orange-600 rounded-xl opacity-0 group-hover:opacity-20 blur-xl transition-all duration-500"></div>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyScripts;
